import React, { useState } from 'react';
import { ClipLoader } from 'react-spinners';
import toast from 'react-hot-toast';
import * as Styled from './style';
import Modal from '../../../../components/Modal/index';
import { useInviteNewMember } from '../../../../services/user.service';
import { TbPlus } from 'react-icons/tb';
import Button from '../../../../components/Button/index';

const AddMember = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const inviteNewMember = useInviteNewMember();
  const [data, setData] = useState({
    name: '',
    email: ''
    // role: '',
    // redirect_url: window?.location?.href || ''
  });

  const handleInputChange = e => {
    try {
      setData(prev => ({
        ...prev,
        [e.target.name]: e.target.value
      }));
    } catch (error) {
      console.error(error);
    }
  };

  const handleInviteNewMember = e => {
    e.preventDefault();

    inviteNewMember.mutate(
      { data: [{ ...data }] },
      {
        onSuccess: () => {
          toast.success(`${data.name} has been invited`);
        },
        onError: err => {
          toast.error(err.data?.detail || 'Something went wrong while inviting a new user');
        }
      }
    );
  };

  return (
    <Styled.AddMemberBtnWrapper>
      <Button
        size="sm"
        variant="outlined"
        leftIcon={<TbPlus fontSize="14px" />}
        onClick={() => setModalOpen(true)}
      >
        Add Member
      </Button>
      <Styled.AddMemberModalWrapper>
        <Modal
          modalClassName="add-member-modal"
          modalBodyClassName="add-member-modal-body"
          open={isModalOpen}
          toggle={() => setModalOpen(!isModalOpen)}
        >
          <div>
            <h4>Member Settings</h4>
            <form onSubmit={handleInviteNewMember}>
              <Styled.FormInputRow>
                <Styled.FormInputWrapper>
                  <label htmlFor="fullname">Member Full Name</label>
                  <input
                    id="fullname"
                    name="name"
                    placeholder="Full name"
                    type="text"
                    required
                    onChange={handleInputChange}
                  />
                </Styled.FormInputWrapper>
                <Styled.FormInputWrapper>
                  <label htmlFor="email">Member Email</label>
                  <input
                    placeholder="Email"
                    name="email"
                    type="email"
                    required
                    onChange={handleInputChange}
                  />
                </Styled.FormInputWrapper>
              </Styled.FormInputRow>
              <Styled.FormInputRow>
                {/*<Styled.FormInputWrapper>*/}
                {/*  <label htmlFor="role">Member Role</label>*/}
                {/*  <input*/}
                {/*    placeholder="Role"*/}
                {/*    name="role"*/}
                {/*    type="text"*/}
                {/*    required*/}
                {/*    onChange={handleInputChange}*/}
                {/*  />*/}
                {/*</Styled.FormInputWrapper>*/}
                <Styled.FormInputWrapper>
                  <Styled.SaveMemberBtn disabled={inviteNewMember.isLoading} type="submit">
                    Save Member{' '}
                    {inviteNewMember.isLoading && <ClipLoader size={20} color="#228be6" />}
                  </Styled.SaveMemberBtn>
                </Styled.FormInputWrapper>
              </Styled.FormInputRow>
            </form>
          </div>
        </Modal>
      </Styled.AddMemberModalWrapper>
      <Styled.AddMemberModalStyleSheet />
    </Styled.AddMemberBtnWrapper>
  );
};

export default AddMember;
